import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../components/Atoms/ProtectedRoute";
import { LayoutTemplate } from "../components/Templates/LayoutTemplate";
import { SchedulesV2 } from "../components/Pages/SchedulesV2";
import { ScheduleDetailV2 } from "../components/Pages/ScheduleDetailV2";
import { Deliverys } from "../components/Pages/Deliverys";
import { Stores } from "../components/Pages/Stores";

export const useNovoAgendamentoRoutes = () => {
  return (
    <Route
      path="meus-agendamentos"
      element={
        <ProtectedRoute>
          <LayoutTemplate />
        </ProtectedRoute>
      }
    >
      <Route index element={<SchedulesV2 />} />
      <Route path="agendamento" element={<ScheduleDetailV2 />} />
      <Route path="deliverys" element={<Deliverys />} />
      <Route path="atendimentos-loja" element={<Stores />} />
    </Route>
  );
};
